import { combineReducers } from "@reduxjs/toolkit";
import channelReducer from "./channel";
import channelAppReducer from "./channelApp";
import detailReducer from "./detail";
import listReducer from "./list";
import auditReducer from "./audit";
import noteReducer from "./note";
import mentionReducer from "./mention";
import messageReducer from "./message";
import leadReducer from "./lead";
import statisticReducer from "./statistic";
import dailyReducer from "./daily";
import channelUiReducer from "./ui";
import taskSlice from "./task";

const ticketReducer = combineReducers({
    detail: detailReducer,
    list: listReducer,
    audit: auditReducer,
    note: noteReducer,
    mention: mentionReducer,
    message: messageReducer,
    lead: leadReducer,
    statistic: statisticReducer,
    channel: channelReducer,
    channelApp: channelAppReducer,
    ui: channelUiReducer,
    daily: dailyReducer,
    task: taskSlice,
});

export default ticketReducer;
